<script lang="ts">
    import {Question} from "../../models/Question";

    export let question: Question;
</script>

<div class="question-dropdown">
    <div style="width: 214px;">&nbsp;</div>
    <div>
        <div class="question-text">{question.text}</div>
        <div>
            <select class="question-select" value="{question.value}">
                <option></option>
                {#each question.dropDownOptions as dropDownOption}
                    <option value="{dropDownOption}">{dropDownOption}</option>
                {/each}
            </select>
        </div>
    </div>
</div>

<style lang="scss">
    @use "../../../component_scss_library/questions";

    .question-dropdown {
      display: flex;
      flex-direction: row;
    }
</style>
